var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.25052H12.75C12.336 5.25052 12 5.58652 12 6.00052C12 6.41452 12.336 6.75052 12.75 6.75052H21.0645L16.4565 10.334L13.152 8.23252L12.348 9.49852L16.098 11.8835C16.2195 11.9615 16.3605 12.0005 16.5 12.0005C16.662 12.0005 16.8255 11.948 16.9605 11.843L22.5 7.53352V17.2505H12.75C12.336 17.2505 12 17.5865 12 18.0005C12 18.4145 12.336 18.7505 12.75 18.7505H23.25C23.664 18.7505 24 18.4145 24 18.0005V6.00052C24 5.58652 23.664 5.25052 23.25 5.25052Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2285 0.922961C13.0575 0.780461 12.828 0.718961 12.612 0.763961L0.612 3.01396C0.2565 3.07996 0 3.38896 0 3.75046V20.2505C0 20.6105 0.2565 20.921 0.612 20.987L12.612 23.237C12.657 23.246 12.7035 23.2505 12.75 23.2505C12.924 23.2505 13.0935 23.1905 13.2285 23.078C13.401 22.9355 13.5 22.7225 13.5 22.5005V1.50046C13.5 1.27696 13.401 1.06546 13.2285 0.922961Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 17.2505C4.683 17.2505 3 15.2315 3 12.7505C3 10.2695 4.683 8.25052 6.75 8.25052C8.817 8.25052 10.5 10.2695 10.5 12.7505C10.5 15.2315 8.817 17.2505 6.75 17.2505ZM6.75 9.75052C5.5095 9.75052 4.5 11.096 4.5 12.7505C4.5 14.405 5.5095 15.7505 6.75 15.7505C7.9905 15.7505 9 14.405 9 12.7505C9 11.096 7.9905 9.75052 6.75 9.75052Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToOutlook);
export default __webpack_public_path__ + "static/media/toOutlook.e330773647fff5a8fb9b62a5c5b7928a.svg";
export { ForwardRef as ReactComponent };